import React, { useRef } from 'react';
import { clsx } from 'clsx';

import type { TopListView } from '../types.js';

import { LinkWithPulse } from '../../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import { usePulseContext } from '../../../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { useRenderContext } from '../../../../contexts/RenderContext.js';
import { useScrollToggle } from '../hooks/useScrollToggle.js';

type TopListHeaderProps = {
  title: string;
  view: TopListView;
  onViewToggle: () => void;
};

const TopListHeader: React.FC<TopListHeaderProps> = ({
  title,
  view,
  onViewToggle,
}) => {
  const { isHermesApp } = useRenderContext();

  const ref = useRef<HTMLDivElement>(null);

  useScrollToggle({
    targetRef: ref,
    scrolledClassName: 'top-list__header--scrolled',
    disabled: view !== 'list',
  });

  const { trackClickUIElement } = usePulseContext();

  const handleToggle = (): void => {
    trackClickUIElement({
      object: {
        id: 'view-toggle',
        name: 'top list view toggle',
        elementType: 'Button',
        custom: {
          targetView: view === 'map' ? 'list' : 'map',
        },
      },
    });

    onViewToggle();
  };

  return (
    <header
      ref={ref}
      className={clsx(`top-list__header top-list__header--${view}`, {
        'top-list__header--web': !isHermesApp,
      })}
    >
      <LinkWithPulse
        className="top-list__back-button"
        href="/mat-og-drikke/restaurantguiden"
        id="back-button"
        name="top list back button"
      >
        Topplister
      </LinkWithPulse>
      {view === 'map' && <h1 className="top-list__header-title">{title}</h1>}
      <button
        onClick={handleToggle}
        className={`top-list__view-toggle top-list__view-toggle--${view}`}
      >
        {view === 'map' ? 'Liste' : 'Kart'}
      </button>
    </header>
  );
};

export { TopListHeader };
